import { MegaphoneIcon } from '@heroicons/react/24/outline';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PhysicianStatusBar = ({ text, detailsUrl, onClick }) => {
  const { t } = useTranslation('components', { keyPrefix: 'PhysicianStatusBar' });

  return (
    <Link
      onClick={onClick}
      to={detailsUrl}
      className="flex bg-amber-200 border-b border-amber-400 text-slate-900 p-2 space-x-2 text-sm items-center"
    >
      <MegaphoneIcon className="w-5 flex-shrink-0" />
      <span className="truncate">{text}</span>
      <span className="underline">{t('read')}</span>
    </Link>
  );
};

PhysicianStatusBar.propTypes = {
  text: PropTypes.string.isRequired,
  detailsUrl: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PhysicianStatusBar;
